import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import winStore from './assets/winStore.svg';
import adBadge from './assets/adBadge.svg';
import getButton from './assets/getButton.svg';
import { getWinStoreStyles } from './styles/win-store';


export const WinStore = ({
  styleOverrides,
}) => {
  const classes = useDefaultStyles(getWinStoreStyles({ styleOverrides }));

  return (
    <div className={classnames('win-store-background', classes.winStoreBackground)}>
      <img className={classnames('win-store-background-image', classes.background)} alt="" src={winStore} />
      <img className={classnames('win-store-ad-badge', classes.adBadge)} alt="" src={adBadge} />
      <img className={classnames('win-store-get-button', classes.getButton)} alt="" src={getButton} />
    </div>
  );
};

WinStore.propTypes = {
  styleOverrides: PropTypes.shape({}),
};

WinStore.defaultProps = {
  styleOverrides: {},
};

